module.exports = __webpack_public_path__ + "assets/ccffcfe4a9db9b897d61fe6e962c00bf.mp4";